import { useState } from 'react';
import { Box, Tab, Tabs } from '@mui/material';
import { Chip, Typography } from '@sm-dashboard/ui-components';

const INFO_SUGGESTIONS = [
  'מה מצב ההתחייבויות שלי?',
  'אילו פעילויות היו לאחרונה?',
  'כמה אנשי קשר יש בכל מעגל?',
  'למי יש יום הולדת החודש?',
  'כמה תרומות קיבלתי החודש?',
  'סכם לי את הפעילות של החודש האחרון'
];

const ACTION_SUGGESTIONS = [
  'הוסף איש קשר חדש',
  'עדכן טלפון לאיש קשר',
  'עדכן כתובת לאיש קשר',
  'עדכן יום הולדת לאיש קשר',
  'הוסף איש קשר למעגל'
];

const TABS = [
  { label: 'מידע', suggestions: INFO_SUGGESTIONS },
  { label: 'פעולות על אנשי קשר', suggestions: ACTION_SUGGESTIONS }
];

interface ChatSuggestionsProps {
  onSelect: (text: string) => void;
}

const ChatSuggestions = ({ onSelect }: ChatSuggestionsProps) => {
  const [tab, setTab] = useState(0);

  return (
    <Box sx={{ display: 'flex', flexDirection: 'column', alignItems: 'center', gap: 2, py: 3, px: 2 }}>
      <Typography variant="body" color="text.secondary">
        אפשר לשאול אותי על אנשי קשר, פעילויות והתחייבויות, וגם לעדכן פרטי איש קשר. למשל:
      </Typography>

      <Tabs value={tab} onChange={(_, value) => setTab(value)} variant="fullWidth" sx={{ alignSelf: 'stretch' }}>
        {TABS.map(({ label }) => (
          <Tab key={label} label={label} sx={{ fontSize: 13 }} />
        ))}
      </Tabs>

      <Box sx={{ display: 'flex', flexWrap: 'wrap', justifyContent: 'center', gap: 1 }}>
        {TABS[tab].suggestions.map(suggestion => (
          <Chip
            key={suggestion}
            label={suggestion}
            variant="primary"
            chipStyle="outlined"
            size="small"
            onClick={() => onSelect(suggestion)}
          />
        ))}
      </Box>
    </Box>
  );
};

export default ChatSuggestions;
